module.exports = __webpack_public_path__ + "res/33-img_card_bg.23046677c83fbbbded531bd1d2a6be86.png";